export const questionsData = [
    // {
    //     "testId": "1",
    //     "testName": "SDQ-CAS",
    //     "instructions": "",
    //     "questions": [
    //         {
    //             "statement": "Tiene en cuenta los sentimientos de otras personas",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala prosocial"
                
    //         },
    //         {
    //             "statement": "Es inquieto/a, hiperactivo/a, no puede permanecer quieto/a por mucho tiempo",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de hiperactividad"
    //         },
    //         {
    //             "statement": "Se queja con frecuencia de dolor de cabeza, de estómago o de náuseas",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de síntomas emocionales"
    //         },
    //         {
    //             "statement": "Comparte frecuentemente con otros niños/as chucherías, juguetes, lápices, etc",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala prosocial"
    //         },
    //         {
    //             "statement": "Frecuentemente tiene rabietas o mal genio",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas de conducta"
    //         },
    //         {
    //             "statement": "Es más bien solitario/a y tiende a jugar solo/a",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas con compañeros/as"
    //         },
    //         {
    //             "statement": "Por lo general es obediente, suele hacer lo que le piden los adultos",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": true,
    //             "category": "Escala de problemas de conducta"
    //         },
    //         {
    //             "statement": "Tiene muchas preocupaciones, a menudo parece inquieto/a o preocupado/a",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de síntomas emocionales"
    //         },
    //         /////////////////////////////////////////////
    //         {
    //             "statement": "Ofrece ayuda cuando alguien resulta herido, disgustado, o enfermo",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala prosocial"
    //         },
    //         {
    //             "statement": "Está continuamente moviéndose y es revoltoso",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de hiperactividad"
    //         },
    //         {
    //             "statement": "Tiene por lo menos un/a buen/a amigo/a",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": true,
    //             "category": "Escala de problemas con compañeros/as"
    //         },
    //         {
    //             "statement": "Pelea con frecuencia con otros niños/as o se mete con ellos/ellas",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas de conducta"
    //         },
    //         {
    //             "statement": "Se siente a menudo infeliz, desanimado o lloroso",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de síntomas emocionales"
    //         },
    //         {
    //             "statement": "Por lo general cae bien a los otros niños/as",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": true,
    //             "category": "Escala de problemas con compañeros/as"
    //         },
    //         {
    //             "statement": "Se distrae con facilidad, su concentración tiende a dispersarse",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de hiperactividad"
    //         },
    //         {
    //             "statement": "Es nervioso/a o dependiente ante nuevas situaciones, fácilmente pierde la confianza en sí mismo/a",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de síntomas emocionales"
    //         },
    //         /////////////////////////////////////
    //         {
    //             "statement": "Trata bien a los niños/as más pequeños/as",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala prosocial"
    //         },
    //         {
    //             "statement": "A menudo miente o engaña",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas de conducta"
    //         },
    //         {
    //             "statement": "Los otros niños/as se meten con él/ella o se burlan de él/ella",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas con compañeros/as"
    //         },
    //         {
    //             "statement": "A menudo se ofrece para ayudar (a padres, maestros, otros niños/as)",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala prosocial"
    //         },
    //         {
    //             "statement": "Piensa las cosas antes de hacerlas",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": true,
    //             "category": "Escala de hiperactividad"
    //         },
    //         {
    //             "statement": "Roba cosas en casa, en la escuela o en otros sitiosz",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas de conducta"
    //         },
    //         {
    //             "statement": "Se lleva mejor con adultos que con otros niños/as",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de problemas con compañeros/as"
    //         },
    //         {
    //             "statement": "Tiene muchos miedos, se asusta fácilmente",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": false,
    //             "category": "Escala de síntomas emocionales"
    //         },
    //         {
    //             "statement": "Termina lo que empieza, tiene buena concentración",
    //             "options": [
    //                 "No es cierto",
    //                 "Un tanto cierto",
    //                 "Absolutamente cierto"
    //             ],
    //             "points": [
    //                 0,
    //                 1,
    //                 2
    //             ],
    //             "reversePoints": true,
    //             "category": "Escala de hiperactividad"
    //         }/////////////////////////////////
    //     ]
    // },
    {
        "testId": "2", 
        "testName": "Inventario de Depresión de Beck II", 
        "instructions": "Lea cada grupo de afirmaciones cuidadosamente, seleccione la que mejor describa la manera en que se ha sentido durante la semana pasada (incluyendo hoy).",
        "questions": 
        [
            {
                "statement": "Tristeza", 

                "options": [
                    "No me siento triste", 
                    "Me siento triste gran parte del tiempo", 
                    "Me siento triste todo el tiempo", 
                    "Me siento tan triste o soy tan infeliz que no puedo soportarlo"], 

                "points": [0, 1, 2, 3]
            }, 
            {
                "statement": "Pesimismo", 

                "options": [
                    "No estoy desalentado respecto del mi futuro", 
                    "Me siento más desalentado respecto de mi futuro que lo que solía estarlo", 
                    "No espero que las cosas funcionen para mi", 
                    "Siento que no hay esperanza para mi futuro y que sólo puede empeorar"], 

                "points": [0, 1, 2, 3]
            }, 
            {
                "statement": "Fracaso", 
                "options": [
                    "No me siento como un fracasado", 
                    "He fracasado más de lo que hubiera debido", 
                    "Cuando miro hacia atrás, veo muchos fracasos", 
                    "Siento que como persona soy un fracaso total"], 
                "points": [0, 1, 2, 3]
            }, 

            {
                "statement": "Pérdida de Placer", 
                "options": [
                    "Obtengo tanto placer como siempre por las cosas de las que disfruto", 
                "No disfruto tanto de las cosas como solía hacerlo", 
                "Obtengo muy poco placer de las cosas que solía disfrutar", 
                "No puedo obtener ningún placer de las cosas de las que solía disfrutar"], 

                "points": [0, 1, 2, 3]
            }, 
            {
                "statement": "Sentimientos de Culpa", 
                "options": [
                    "No me siento particularmente culpable", 
                "Me siento culpable respecto de varias cosas que he hecho o que debería haber hecho",
                "Me siento bastante culpable la mayor parte del tiempo", 
                "Me siento culpable todo el tiempo"], 

                "points": [0, 1, 2, 3]
            }, 
            {
                "statement": "Sentimientos de Castigo", 
                "options": [
                    "No siento que este siendo castigado", 
                    "Siento que tal vez pueda ser castigado", 
                    "Espero ser castigado", 
                    "Siento que estoy siendo castigado"], 

                "points": [0, 1, 2, 3]
            }, 
            {
                "statement": "Disconformidad con uno mismo", 
                "options": [
                    "Siento acerca de mi lo mismo que siempre", 
                    "He perdido la confianza en mí mismo", 
                    "Estoy decepcionado conmigo mismo", 
                    "No me gusto a mí mismo"], 

                "points": [0, 1, 2, 3]
            }, 
            {
                "statement": "Autocrítica", 
                "options": [
                    "No me critico ni me culpo más de lo habitual",
                "Estoy más crítico conmigo mismo de lo que solía estarlo", 
                "Me critico a mí mismo por todos mis errores", 
                "Me culpo a mí mismo por todo lo malo que sucede"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Pensamientos o Deseos Suicidas", 
                "options": [
                    "No tengo ningún pensamiento de matarme",
                    "He tenido pensamientos de matarme, pero no lo haría", 
                    "Querría matarme", 
                    "Me mataría si tuviera la oportunidad de hacerlo"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Llanto", 
                "options": [
                    "No lloro más de lo que solía hacerlo",
                    "Lloro más de lo que solía hacerlo ", 
                    "Lloro por cualquier pequeñez", 
                    "Siento ganas de llorar pero no puedo"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Agitación", 
                "options": [
                    "No estoy más inquieto o tenso que lo habitual",
                    "Me siento más inquieto o tenso que lo habitual", 
                    "Estoy tan inquieto o agitado que me es difícil quedarme quieto", 
                    "Estoy tan inquieto o agitado que tengo que estar siempre en movimiento o haciendo algo"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Pérdida de Interés", 
                "options": [
                    "No he perdido el interés en otras actividades o personas",
                    "Estoy menos interesado que antes en otras personas o cosas", 
                    "He perdido casi todo el interés en otras personas o cosas", 
                    "Me es difícil interesarme por algo"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Indecisión", 
                "options": [
                    "Tomo mis propias decisiones tan bien como siempre",
                    "Me resulta más difícil que de costumbre tomar decisiones", 
                    " Encuentro mucha más dificultad que antes para tomar decisiones", 
                    "Tengo problemas para tomar cualquier decisión"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Desvalorización", 
                "options": [
                    "No siento que yo no sea valioso",
                    "No me considero a mi mismo tan valioso y útil como solía considerarme", 
                    "Me siento menos valioso cuando me comparo con otros", 
                    "Siento que no valgo nada"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Pérdida de Energía ", 
                "options": [
                    "Tengo tanta energía como siempre",
                    "Tengo menos energía que la que solía tener", 
                    "No tengo suficiente energía para hacer demasiado", 
                    "No tengo energía suficiente para hacer nada"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Cambios en los Hábitos de Sueño", 
                "options": [
                    "No he experimentado ningún cambio en mis hábitos de sueño",
                    "Duermo un poco más que lo habitual", 
                    "Duermo un poco menos que lo habitual", 
                    "Duermo mucho más que lo habitual",
                    "Duermo mucho menos que lo habitual",
                    "Duermo la mayor parte del día",
                    "Me despierto 1-2 horas más temprano y no puedo volver a dormirme",
                ], 

                "points": [0, 1, 1, 2, 2, 3, 3]
            },
            {
                "statement": "Irritabilidad", 
                "options": [
                    "No estoy tan irritable que lo habitual",
                    "Estoy más irritable que lo habitual", 
                    "Estoy mucho más irritable que lo habitual", 
                    "Estoy irritable todo el tiempo"
                ], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Cambios en el Apetito", 
                "options": [
                    "No he experimentado ningún cambio en mi apetito",
                    "Mi apetito es un poco menor que lo habitual", 
                    "Mi apetito es un poco mayor que lo habitual", 
                    "Mi apetito es mucho menor que antes",
                    "Mi apetito es mucho mayor que lo habitual",
                    "No tengo apetito en absoluto",
                    "Quiero comer todo el día",
                ], 

                "points": [0, 1, 1, 2, 2, 3, 3]
            },
            {
                "statement": "Dificultad de Concentración", 
                "options": [
                    "Puedo concentrarme tan bien como siempre",
                    "No puedo concentrarme tan bien como habitualmente", 
                    "Me es difícil mantener la mente en algo por mucho tiempo", 
                    "Encuentro que no puedo concentrarme en nada"
                ], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Cansancio o Fatiga", 
                "options": [
                    "No estoy más cansado o fatigado que lo habitual",
                    "Me fatigo o me canso más fácilmente que lo habitual", 
                    "Estoy demasiado fatigado o cansado para hacer muchas de las cosas que solía hacer", 
                    "Estoy demasiado fatigado o cansado para hacer la mayoría de las cosas que solía hacer"
                ], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Pérdida de Interés en el Sexo ", 
                "options": [
                    "No he notado ningún cambio reciente en mi interés por el sexo",
                    "Estoy menos interesado en el sexo de lo que solía estarlo", 
                    "Estoy mucho menos interesado en el sexo", 
                    "He perdido completamente el interés en el sexo"
                ], 

                "points": [0, 1, 2, 3]
            },
        ]
    },
    {
        "testId": "3", 
        "testName": "Inventario de Ansiedad de Beck", 
        "instructions": "A continuación se presentan una lista de síntomas comunes de la ansiedad. Indique cuánto le han molestado estos síntomas durante la última semana (incluyendo hoy)." ,
        "questions": 
        [
            {
                "statement": "Hormigueo o cosquilleos", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Calor", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Piernas débiles", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Incapaz de relajarme", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Temor de que lo peor sucederá", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Mareos", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Palpitaciones o taquicardia", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Inestabilidad o pérdida del equilibrio", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Miedo", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Nerviosismo", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Sensación de ahogo", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Temblor de manos", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Escalofríos", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Temor de perder el control", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Dificultad para respirar", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Temor a morir", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Sentirme asustado", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Molestias estomacales", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Desmayos", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Rubor (enrojecimiento) en cara", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            },
            {
                "statement": "Más sudor de lo usual", 

                "options": [
                    "Nada", 
                    "Poco", 
                    "Regular", 
                    "Mucho"], 

                "points": [0, 1, 2, 3]
            }  
        ]
    },
    {
        "testId": "4", 
        "testName": "Tamizaje de probioticos", 
        "instructions": "Lea cada una de las preguntas detenidamente y seleccione la respuesta que mejor describa su situación actual.",
        "questions": 
        [
            {
                "statement": "¿Ha tomado antibíoticos en el último año?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Tiene problemas digestivos (diarrea, estreñimiento, gases)?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Ha sufrido de intoxicación alimenticia?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Sufre de fatiga crónica?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Tiende a tener la piel seca?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Se siente deprimido o ansioso con frecuencia?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Sufre de asma o alergias?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Se enferma con frecuencia?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Ha tenido infecciones por hongos?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
        ]
    },
    {
        "testId": "5", 
        "testName": "Cuestionario de adherencia a la dieta mediterranea", 
        "instructions": "Con este cuestionario podrá conocer cuáles son sus hábitos alimentarios. Responda a las preguntas que se le plantean.",
        "questions": 
        [
            {
                "statement": "¿Usa usted el aceite de oliva como principal grasa para cocinar?", 

                "options": [
                    "Sí", 
                    "No"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuánto aceite de oliva consume en total al día (incluyendo el usado para freír, comidas fuera de casa, ensaladas, etc.)?", 

                "options": [
                    "2 o más cucharadas al día", 
                    "Menos de 2 al día"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuántas raciones de verdura u hortalizas consume al día? (las guarniciones o acompañamientos = ½ ración)", 

                "options": [
                    "2 o más al dia (al menos una de ellas en ensaladas o crudas)", 
                    "Menos de 2 al día"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas piezas de fruta (incluyendo zumo natural) consume al día?", 

                "options": [
                    "3 o más al dia", 
                    "Menos de 3 al día"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas raciones de carnes rojas, hamburguesas, salchichas o embutidos consume al día? (una ración equivale a: 100 - 150 g)", 

                "options": [
                    "Menos de una al día", 
                    "Más de 1 al dia"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas raciones de mantequilla, margarina o nata consume al día? (porción individual: 12 g)", 

                "options": [
                    "Menos de una al día", 
                    "Más de 1 al dia"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas bebidas carbonatadas y/o azucaradas (refrescos, colas, tónicas, bitter) consume al día? (porción individual: 12 g)", 

                "options": [
                    "Menos de una al día", 
                    "Más de 1 al dia"],

                "points": [1,0]
            },
            {
                "statement": "¿Bebe usted vino? ¿Cuánto consume a la semana? (porción individual: 12 g)", 

                "options": [
                    "3 o más vasos por semana", 
                    "Menos de 3 vasos por semana"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas raciones de legumbres consume a la semana? (1 plato o ración equivale a 150 g)", 

                "options": [
                    "3 o más por semana", 
                    "Menos de 3 por semana"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas raciones de pescado-mariscos consume a la semana? (1 plato pieza o ración: 100 - 150 de pescado o 4-5 piezas o 200 g de marisco)", 

                "options": [
                    "3 o más por semana", 
                    "Menos de 3 por semana"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas veces consume reposteria comercial (no casera) como galletas, flanes, dulce o pasteles a la semana?", 

                "options": [
                    "Menos de 3 por semana", 
                    "Más de 3 por semana"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas veces consume frutos secos a la semana? (ración 30 g)", 

                "options": [
                    "Una o más por semana", 
                    "No consumo"],

                "points": [1,0]
            },
            {
                "statement": "¿Consume preferentemente carne de pollo, pavo o conejo en vez de ternera, cerdo, hamburguesas o salchichas? (ración 30 g)", 

                "options": [
                    "Sí", 
                    "No"],

                "points": [1,0]
            },
            {
                "statement": "¿Cuantas veces a la semana consume los vegetales cocinados, la pasta, arroz u otros platos aderezados con salsa de tomate, ajo, cebolla o puerro elaborada a fuego lento con aceite de oliva (sofrito)?", 

                "options": [
                    "2 o más al por semana", 
                    "Menos de 2 por semana"],

                "points": [1,0]
            }
        ]
    },
    {
        "testId": "6", 
        "testName": "Tamizaje vitamina D", 
        "instructions": "Lea cada una de las preguntas detenidamente y seleccione la respuesta que mejor describa su situación actual.",
        "questions": 
        [
            {
                "statement": "¿Se ha fracturado un hueso sin haberse caído?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Sus músculos están flojos a pesar de hacer ejercicio?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Sufre de dolor crónico que no se alivia con medicamentos?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Sufre de cansancio?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Tiende a estar triste?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Toma antidrepresivos, esteroides anticoagulantes?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Con frecuencia nota sus encías muy rojas e inflamadas?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Se enferma de gripe con frecuencia?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Ha aumentado de peso sin comer más calorías?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Su piel es muy oscura todo el año?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Tiene problemas digestivos?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            },
            {
                "statement": "¿Le cuesta controlar su presión alta, pese a medicarse?", 

                "options": [
                    "Verdadero", 
                    "Falso"],

                "points": [1,0]
            }
        ]
    },
    // {
    //     "testId": "", 
    //     "testName": "PRUEBA7", 
    //     "instructions": "",
    //     "questions": 
    //     [
    //     ]
    // },
    {
        "testId": "8",
        "testName": "Inventario de desesperanza de BECK",
        "instructions": "A continuación se presenta una serie de afirmaciones. Por favor, lea cada una y responda si para usted es Verdadero o Falso.",
        "questions": [
            {
                "statement": "Espero el futuro con esperanza y entusiasmo",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "Puedo darme por vencido, renunciar, ya que no puedo hacer mejor las cosas por mí mismo",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Cuando las cosas van mal me alivia saber que las cosas no pueden permanecer tiempo así",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "No puedo imaginar como será mi vida dentro de 10 años",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Tengo bastante tiempo para llevar a cabo las cosas que quisiera poder hacer",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "En el futuro, espero conseguir lo que me pueda interesar",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "Mi futuro me parece oscuro",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Espero más cosas buenas de la vida que lo que la gente suele conseguir por término medio",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "No logro hacer que las cosas cambien, y no existen razones para creer que pueda en el futuro",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Mis pasadas experiencias me han preparado bien para mi futuro",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "Todo lo que puedo ver por delante de mí es más desagradable que agradable",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "No espero conseguir lo que realmente deseo",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Cuando miro hacia el futuro, espero que seré más feliz de lo que soy ahora",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "Las cosas no marchan como yo quisiera",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Tengo una gran confianza en el futuro",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "Nunca consigo lo que deseo, por lo que es absurdo desear cualquier cosa",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "Es muy improbable que pueda lograr una satisfacción real en el futuro",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "El futuro me parece vago e incierto",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            },
            {
                "statement": "No puedo imaginar que mi vida cambie para bien",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [0, 1]
            },
            {
                "statement": "Mi vida no va a ser mejor de lo que es ahora",
                "options": [
                    "Verdadero",
                    "Falso"
                ],
                "points": [1, 0]
            }
        ]
    },
    {
        "testId": "9", 
        "testName": "Cuestionario Salamanca de Trastornos de la Personalidad", 
        "instructions": "Este es un cuestionario para la valoración de algunos de sus rasgos de personalidad. Conteste según sea su manera de ser habitual y no según se encuentre en un momento dado.",
        "questions": 
        [
            {
                "statement": "Pienso que más vale no confiar en los demás",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Me gustaría dar a la gente su merecido",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Prefiero realizar actividades que pueda hacer yo solo",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Prefiero estar conmigo mismo",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "¿Piensa la gente que es usted raro, excéntrico...?",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Estoy más en contacto con lo paranormal que la mayoría de la gente",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Soy demasiado emocional",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Doy mucha importancia y atención a mi imagen",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Hago cosas que están fuera de la ley",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Tengo poco respeto por los derechos de los demás",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Creo que soy especial y merezco que me lo reconozcan",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Mucha gente me envidia por mi valía",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "¿Sus emociones son como una montaña rusa?",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "¿Es usted impulsivo?",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "¿Se pregunta con frecuencia cuál es su papel en la vida?",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "¿Se siente aburrido y vacío con facilidad?",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "¿Le considera la gente demasiado perfeccionista, obstinado, rígido...?",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Soy detallista, minucioso y demasiado trabajador",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Necesito sentirme cuidado y protegido por los demás",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Me cuesta tomar decisiones por mí mismo",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Soy nervioso",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              },
              {
                "statement": "Tengo mucho miedo a hacer el ridículo",
                "options": ["No estoy de acuerdo", "A veces", "Con frecuencia", "Siempre"],
                "points": [0, 1, 2, 3]
              }
        ]
    },
    {
        "testId": "10", 
        "testName": "Cuestionario de Trastornos del humor", 
        "instructions": "Responda cada una de las preguntas lo mejor que pueda.",
        "questions": 
        [
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: se sintiera tan bien o tan activo que otras personas han pensado que no estaba en su estado normal o que estaba tan hiperactivo que tenía problemas?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: estaba tan irritable que gritaba a la gente o se metía en peleas o discusiones?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: se sentía mucho más seguro que normalmente?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: dormía mucho menos de lo habitual y creía que realmente no era importante?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: estaba más hablador y hablaba mucho más rápido de lo habitual?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: sus pensamientos iban más rápidos en su cabeza y no podía frenar su mente?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: se distraía fácilmente por las cosas del alrededor o ha tenido problemas para concentrarse en lo que estaba haciendo o seguir el hilo?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: tenía mucha más energía de lo habitual?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: estaba mucho más activo o hacía muchas más cosas de lo habitual?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: era mucho más social o extrovertido de lo habitual, por ejemplo, llamaba a la gente a altas horas de la noche?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: tenía mucho más interés en el sexo de lo habitual?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: hizo cosas que eran inusuales para usted o que otras personas pudieran pensar que eran excesivas, estúpidas o arriesgadas?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Ha tenido alguna vez algún periodo de tiempo en el que no se sintiera usted mismo y: ha gastado dinero que le trajera problemas a usted o a su familiar?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "Si ha respondido que SÍ a más de una de las preguntas anteriores, ¿Han ocurrido estos varios de estos problemas durante el mismo periodo de tiempo?",
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "¿Cuánto problema le han causado alguna de estas cosas: en el trabajo; problemas con la familia, el dinero o legales; metiéndose en peleas o discusiones? (Si no ha tenido ningún problema, marque 0)",
                "options": ["Sin problema", "Pequeño", "Moderado", "Serio"],
                "points": [0, 1, 2, 3]
            },
            {
                "statement": "¿Ha tenido alguno de sus parientes (p. eje., hijos, hermanos, padres, abuelos, tías, tíos) una enfermedad de tipo maníaco-depresivo o trastorno bipolar?",	
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
            {
                "statement": "Le ha dicho alguna vez un profesional de la salud que usted tiene una enfermedad maníaco-depresiva o trastorno bipolar?",	
                "options": ["Sí", "No"],
                "points": [1, 0]
            },
        ]
    },
    {
        "testId": "11", 
        "testName": "Cuestionario Internacional de Actividad Física",
        "instructions": "Estamos interesados en saber acerca de la clase de actividad física que la gente hace como parte de su vida diaria...",
        "questions":
        [

        ]
    }
    
]